import { render, staticRenderFns } from "./AfterSaleType.vue?vue&type=template&id=c3e03108&scoped=true&"
import script from "./AfterSaleType.vue?vue&type=script&lang=js&"
export * from "./AfterSaleType.vue?vue&type=script&lang=js&"
import style0 from "./AfterSaleType.vue?vue&type=style&index=0&id=c3e03108&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e03108",
  null
  
)

export default component.exports